"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _react = _interopRequireDefault(require("react"));
var _default = exports["default"] = function _default(errorCategory, packageVersion) {
  return function (WrappedComponent) {
    var Component = function Component(props) {
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, {
        errorCategory: errorCategory,
        version: packageVersion
      }));
    };
    (0, _hoistNonReactStatics["default"])(Component, WrappedComponent);
    Component.propTypes = WrappedComponent.propTypes;
    Component.displayName = WrappedComponent.displayName || WrappedComponent.name || 'withLoggerData';
    return Component;
  };
};